export enum queryParams {
  LANG = 'lang',
}
